import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Context } from '../../../../context/AppContext';
import resizeImage from '../../../../utils/resizeImage';
import filterProfileUrl from '../../../../utils/filterProfileUrl';
import generateProfileUrl from '../../../../utils/profileUrl';
import useCheckBestImage from '../../../../hooks/useCheckBestImage';
import { ReviewStars } from '../../../Review';
import Truncate from '../../../Truncate';
import LazyLoad from '../../../LazyLoad';
import Image from '../../../Image';
import defaultProfileImageJpg from '../../../../assets/defaultProfileImage.jpg';
import defaultProfileImageWebp from '../../../../assets/defaultProfileImage.webp';
import './styles.css';

const FeaturedItem = ({
  name,
  averageRating,
  count,
  profileUrl,
  categoryName,
  displayReviews,
  images,
  suburbName,
  state,
  hideSuburb,
  hash,
}) => {
  const {
    webp,
    media: { mobile },
  } = useContext(Context);

  const [imageError, setImageError] = useState();
  const { bestImage } = useCheckBestImage(images);
  const { src, placeholder } = bestImage || {};

  return (
    <div
      className={classNames('BusinessesList__FeaturedItem__root', {
        'BusinessesList__FeaturedItem__root--mobile': mobile,
      })}
    >
      <div className="BusinessesList__FeaturedItem__content">
        <Link
          to={
            suburbName && state && name && hash
              ? generateProfileUrl({
                  name,
                  suburb: suburbName,
                  state,
                  hash,
                })
              : filterProfileUrl(profileUrl)
          }
          className="BusinessesList__FeaturedItem__link"
        >
          {name}
        </Link>
        <div
          className={classNames('BusinessesList__FeaturedItem__image', {
            'BusinessesList__FeaturedItem__image--placeholder':
              placeholder || imageError,
          })}
        >
          {!hideSuburb && suburbName && state && (
            <span className="BusinessesList__FeaturedItem__location">
              {suburbName} {state}
            </span>
          )}
          <LazyLoad>
            <div className="BusinessesList__FeaturedItem__imageWrapper">
              {placeholder ? (
                <Image
                  src={defaultProfileImageWebp}
                  fallback={defaultProfileImageJpg}
                  alt={`Featured ${name}`}
                />
              ) : (
                <img
                  src={resizeImage(src, {
                    width: 295,
                    height: 295,
                    fit: 'cover',
                    webp,
                  })}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = defaultProfileImageJpg;
                    setImageError(true);
                  }}
                  alt={`Featured ${name}`}
                />
              )}
            </div>
          </LazyLoad>
        </div>
        {categoryName && (
          <div className="BusinessesList__FeaturedItem__category">
            {categoryName}
          </div>
        )}

        {name && (
          <Truncate lines={2}>
            <div className="BusinessesList__FeaturedItem__name">{name}</div>
          </Truncate>
        )}
        {!!displayReviews && !!averageRating && (
          <ReviewStars
            countText={`(${count})`}
            rating={averageRating}
            width={mobile ? 13 : 15}
          />
        )}
      </div>
    </div>
  );
};

export default FeaturedItem;
